<template>
  <div class="container-fluid">
    <section id="intro">
      <!-- <div class="announce-btn col-md-2 offset-md-5 col-8 offset-2">
        <router-link :to="{ name: 'Announce'}">
          <h3>ประกาศผล</h3>
        </router-link>
      </div> -->
      <div id="particles-js"></div>
    </section>
    <section id="about" class="col-md-10 offset-md-1">
      <div class="row">
        <div class="col-md-3">
          <img src="/static/assets/img/about_img.png" class="about-img flip">
        </div>
        <div class="col-md-6 about-info text-center">
          <img src="/static/assets/img/about_title.png" class="about-title">
          <p>ค่ายพี่สอนน้องเด็กคอมมินิแคมป์ ครั้งที่ 6 เป็นค่ายที่เหมาะสำหรับนักเรียนในทุกระดับชั้น ที่มีความสนใจและมีความสามารถในเรื่องของเทคโนโลยีสารสนเทศ ที่ได้รังสรรค์ขึ้นจากพี่ๆนักเรียนเก่าชมรมเด็กคอม มาร่วมกันเป็นส่วนหนึ่งในความทรงจำกับค่ายพี่สอนน้องเด็กคอมมินิแคมป์ ครั้งที่ 6 ด้วยกันนะ..</p>
        </div>
        <div class="col-md-3">
          <img src="/static/assets/img/about_img.png" class="about-img">
        </div>
      </div>
    </section>
    <section id="branchs" class="col-md-10 offset-md-1">
      <div class="row">
        <div class="col-md-4 offset-md-4 col-10 mx-auto">
          <h3 class="branch-title">เลือกสาขา</h3>
        </div>
        <div class="w-100"></div>
        <div class="col-md-3 col-12 branch-item-div">
          <!-- <router-link :to="{ name: 'Announce'}"> -->
          <!-- <router-link :to="{ name: 'Register', params: {branchs: 'Programing' } }"> -->
            <!-- <a href="https://docs.google.com/forms/d/1QSl-VKyov0SZM4hPvgRYozyIVgnLl2R4nY58frtWOGw/"> -->
            <img src="/static/assets/img/paper_scroll_progaming.png" class="branch-img">
            <!-- </a> -->
          <!-- </router-link> -->
          <!-- <h4 class="branch-count">ผู้สมัคร {{ count_programing }} คน</h4> -->
        </div>
        <div class="col-md-3 col-12 branch-item-div">
          <!-- <router-link :to="{ name: 'Announce'}"> -->
          <!-- <router-link :to="{ name: 'Register', params: {branchs: 'Multimedia' } }"> -->
            <!-- <a href="https://docs.google.com/forms/d/1QSl-VKyov0SZM4hPvgRYozyIVgnLl2R4nY58frtWOGw/"> -->
            <img src="/static/assets/img/paper_scroll_multimedia.png" class="branch-img">
            <!-- </a> -->
          <!-- </router-link> -->
          <!-- <h4 class="branch-count">ผู้สมัคร {{ count_multimedia }} คน</h4> -->
        </div>
        <div class="col-md-3 col-12 branch-item-div">
          <!-- <router-link :to="{ name: 'Announce'}"> -->
          <!-- <router-link :to="{ name: 'Register', params: {branchs: 'Graphic' } }"> -->
            <!-- <a href="https://docs.google.com/forms/d/1QSl-VKyov0SZM4hPvgRYozyIVgnLl2R4nY58frtWOGw/"> -->
            <img src="/static/assets/img/paper_scroll_graphic.png" class="branch-img">
            <!-- </a> -->
          <!-- </router-link> -->
          <!-- <h4 class="branch-count">ผู้สมัคร {{ count_graphic }} คน</h4> -->
        </div>
        <div class="col-md-3 col-12 branch-item-div">
          <!-- <router-link :to="{ name: 'Announce'}"> -->
          <!-- <router-link :to="{ name: 'Register', params: {branchs: 'Robot' } }"> -->
            <!-- <a href="https://docs.google.com/forms/d/1QSl-VKyov0SZM4hPvgRYozyIVgnLl2R4nY58frtWOGw/"> -->
            <img src="/static/assets/img/paper_scroll_robot.png" class="branch-img">
            <!-- </a> -->
          <!-- </router-link> -->
          <!-- <h4 class="branch-count">ผู้สมัคร {{ count_robot }} คน</h4> -->
        </div>
      </div>
    </section>
    <section id="timelines" class="col-md-6 offset-md-3">
      <div class="col-md-4 offset-md-4 col-10">
        <h3 class="timelines-title">ตารางเวลา</h3>
      </div>
      <ul class="timeline">
        <li>
          <div class="timeline-badge">
            <i class="glyphicon glyphicon-check"></i>
          </div>
          <div class="timeline-panel">
            <div class="timeline-heading">
              <h4 class="timeline-title">รับสมัคร</h4>
            </div>
            <div class="timeline-body">
              <p>วันนี้ - 9 สิงหาคม</p>
            </div>
          </div>
        </li>
        <li class="timeline-inverted">
          <div class="timeline-badge warning">
            <i class="glyphicon glyphicon-credit-card"></i>
          </div>
          <div class="timeline-panel">
            <div class="timeline-heading">
              <h4 class="timeline-title">ประกาศผล</h4>
            </div>
            <div class="timeline-body">
              <p>10 สิงหาคม</p>
            </div>
          </div>
        </li>
        <li>
          <div class="timeline-badge">
            <i class="glyphicon glyphicon-check"></i>
          </div>
          <div class="timeline-panel">
            <div class="timeline-heading">
              <h4 class="timeline-title">ยืนยันสิทธิ์</h4>
            </div>
            <div class="timeline-body">
              <p>10 สิงหาคม - 16 สิงหาคม</p>
            </div>
          </div>
        </li>
        <li class="timeline-inverted">
          <div class="timeline-badge warning">
            <i class="glyphicon glyphicon-credit-card"></i>
          </div>
          <div class="timeline-panel">
            <div class="timeline-heading">
              <h4 class="timeline-title">วันค่าย</h4>
            </div>
            <div class="timeline-body">
              <p>25 สิงหาคม - 26 สิงหาคม</p>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <section id="gallery" class="col-md-6 offset-md-3 col-10 mx-auto">
      <carousel :loop="true" :autoplay="true" :perPage="1" :paginationEnabled="false">
        <slide>
          <img src="https://scontent.fbkk13-1.fna.fbcdn.net/v/t31.0-8/13708263_1390782884281976_6956723089871239781_o.jpg?_nc_cat=0&_nc_eui2=AeFw3_pfvB2Z-LznWsgfNLHMAVy7bFZCEwFQu1tCA-mcB8te-R487WGfZ3CCGmq0z4oZM6XgmsJ-pZDdwQFmOkMNEgtY6h-VDH-36L33mePwVQ&oh=7c8e2c3809a8ae78b73a2301a237c5e0&oe=5BD09EB6" class="gallery-img">
        </slide>
        <slide v-for="gallery_item in gallery_items">
          <img :src="gallery_item.url" class="gallery-img">
        </slide>
      </carousel>
      <h5 class="gallery-title">ภาพกิจกรรม</h5>
    </section>
    <section id="contact" class="col-md-10 offset-md-1">
      <div class="row">
        <div class="col-md-4 offset-md-2 col-10 offset-1 contact-info">
          <h3 class="contact-title">ติดต่อสอบถาม</h3>
          <h3>พี่น้ำผึ้ง 090-942-5664</h3>
          <h3>พี่เล็ก 099-619-9642</h3>
          <a href="https://www.facebook.com/DekComCamp/">
            <img src="/static/assets/img/fb.png" class="contact-fb">
          </a>
        </div>
        <div class="col-md-6">
          <img src="/static/assets/img/contact_img.png" class="contact-img">
        </div>
      </div>
    </section>
    <section id="university" class="col-md-6 offset-md-3">
      <div class="row">
        <div class="col-md-3 col-6 mx-auto uni-box">
          <img src="/static/assets/img/university/KU.png" class="uni-img">
        </div>
        <div class="col-md-3 col-6 mx-auto uni-box">
          <img src="/static/assets/img/university/SWU.png" class="uni-img">
        </div>
        <div class="col-md-3 col-6 mx-auto uni-box">
          <img src="/static/assets/img/university/TNI.png" class="uni-img">
        </div>
        <div class="col-md-3 col-6 mx-auto uni-box">
          <img src="/static/assets/img/university/TU.png" class="uni-img">
        </div>
        <div class="col-md-3 col-6 mx-auto uni-box">
          <img src="/static/assets/img/university/DPU.png" class="uni-img">
        </div>
        <div class="col-md-3 col-6 mx-auto uni-box">
          <img src="/static/assets/img/university/KMITL.png" class="uni-img">
        </div>
        <div class="col-md-3 col-6 mx-auto uni-box">
          <img src="/static/assets/img/university/KMUTNB.png" class="uni-img">
        </div>
        <div class="col-md-3 col-6 mx-auto uni-box">
          <img src="/static/assets/img/university/KMUTT.png" class="uni-img">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import "particles.js";
import { Carousel, Slide } from "vue-carousel";
import firebase from "firebase/app";
import "firebase/database";

export default {
  name: "Home",
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      gallery_items: [
        {
          url: "/static/assets/img/gallery/gallery-1.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-2.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-3.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-4.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-5.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-6.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-7.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-8.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-9.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-10.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-11.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-12.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-13.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-14.jpg"
        },
        {
          url: "/static/assets/img/gallery/gallery-15.jpg"
        }
      ],
      count_graphic: 0,
      count_robot: 0,
      count_multimedia: 0,
      count_programing: 0
    };
  },
  mounted() {
    window.particlesJS.load(
      "particles-js",
      "/static/assets/js/particles/particles.json",
      null
    );

    firebase
      .database()
      .ref()
      .child("users")
      .once("value", snapshot => {
        snapshot.forEach(child => {
          if (child.val().branch === "Programing") {
            this.count_programing++;
          } else if (child.val().branch === "Graphic") {
            this.count_graphic++;
          } else if (child.val().branch === "Multimedia") {
            this.count_multimedia++;
          } else if (child.val().branch === "Robot") {
            this.count_robot++;
          }
        });
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.fullscreen {
  min-height: 100vh;
}

.container-fluid {
  padding: 0;
  background: linear-gradient(#8e1625, #240b36);
  overflow: hidden;
}

/* Intro */
#intro {
  background: url("/static/assets/img/intro_bg.svg") center no-repeat;
  background-size: cover;
  height: 100vh;
}
#particles-js {
  height: 100vh;
}

/* About */
#about {
  color: #fff;
  margin: 10vh auto;
}

.about-info {
  line-height: 34px;

  & > p {
    padding-top: 10px;
    font-size: 20px;
  }
}

.about-title {
  width: 40%;
}

.about-img {
  width: 200%;
  &.flip {
    transform: scaleX(-1);
    position: relative;
    left: -100%;
  }
}

@media (max-width: 768px) {
  .about-info {
    position: relative;
    top: -15vh;
  }

  #about {
    margin-bottom: 0;
  }
}

/* Branch */
#branchs {
  text-align: center;
  margin: 10vh auto;
}

.branch-title {
  color: #fff;
  padding: 10px;
  border: 4px solid #fff;
}

.branch-item-div {
  padding: 30px;
}

.branch-img {
  width: 100%;
}

.branch-count {
  color: #fff;
  margin-top: 15px;
}

@media (max-width: 767px) {
  #branchs {
    margin-top: 0;
  }
}

/* Timeline */
#timelines {
  text-align: center;
  margin: 10vh auto;
}

.timelines-title {
  color: #fff;
  padding: 10px;
  border: 4px solid #fff;
  position: relative;
  top: 10px;
}

.timeline {
  list-style: none;
  padding: 20px 0 20px;
  position: relative;
  color: #fff;
}

.timeline:before {
  top: 0;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 5px;
  background-color: #fff;
  left: 50%;
  margin-left: -2.5px;
  border-radius: 10px;
}

.timeline > li {
  margin-bottom: 20px;
  position: relative;
}

.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}

.timeline > li:after {
  clear: both;
}

.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}

.timeline > li:after {
  clear: both;
}

.timeline > li > .timeline-panel {
  width: 41%;
  float: left;
  border: 4px solid #fff;
  border-radius: 2px;
  padding: 20px;
  position: relative;
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
}

.timeline > li > .timeline-panel:before {
  position: absolute;
  top: 26px;
  right: -15px;
  display: inline-block;
  border-top: 15px solid transparent;
  border-left: 15px solid #fff;
  border-right: 0 solid #fff;
  border-bottom: 15px solid transparent;
  content: " ";
}

.timeline > li > .timeline-panel:after {
  position: absolute;
  top: 27px;
  right: -14px;
  display: inline-block;
  border-top: 14px solid transparent;
  border-left: 14px solid #fff;
  border-right: 0 solid #fff;
  border-bottom: 14px solid transparent;
  content: " ";
}

.timeline > li > .timeline-badge {
  color: #5c122e;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 1.4em;
  text-align: center;
  position: absolute;
  top: 30px;
  left: 50%;
  margin-left: -15px;
  background-color: #fff;
  z-index: 100;
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
}

.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}

.timeline > li.timeline-inverted > .timeline-panel:before {
  border-left-width: 0;
  border-right-width: 15px;
  left: -15px;
  right: auto;
}

.timeline > li.timeline-inverted > .timeline-panel:after {
  border-left-width: 0;
  border-right-width: 14px;
  left: -14px;
  right: auto;
}

.timeline-title {
  margin-top: 0;
  color: inherit;
}

.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0;
}

.timeline-body > p + p {
  margin-top: 5px;
}

@media (max-width: 767px) {
  ul.timeline:before {
    left: 40px;
  }

  ul.timeline > li > .timeline-panel {
    width: calc(100% - 90px);
    width: -moz-calc(100% - 90px);
    width: -webkit-calc(100% - 90px);
  }

  ul.timeline > li > .timeline-badge {
    left: 25px;
    margin-left: 0;
    top: 30px;
  }

  ul.timeline > li > .timeline-panel {
    float: right;
  }

  ul.timeline > li > .timeline-panel:before {
    border-left-width: 0;
    border-right-width: 15px;
    left: -15px;
    right: auto;
  }

  ul.timeline > li > .timeline-panel:after {
    border-left-width: 0;
    border-right-width: 14px;
    left: -14px;
    right: auto;
  }
}

/* Gallery */
#gallery {
  border: 20px solid #fff;
  box-shadow: 0 0 10px #fff;
  padding: 0;
  margin: 10vh auto;
  background: #fff;
  text-align: center;
}

.gallery-img {
  width: 100%;
}

.gallery-title {
  padding-top: 15px;
  margin: 0;
  color: #350e34;
}

/* Contact */
#contact {
  margin: 10vh auto;
  text-align: center;
}

.contact-info {
  background: #fff;
  padding: 15px;
  border-radius: 10px;
}

.contact-title {
  color: #350e34;
  border-bottom: 2px dashed #350e34;
  padding-bottom: 10px;
  margin-bottom: 30px;
}

.contact-img {
  width: 60%;
}

.contact-fb {
  margin-top: 20px;
  width: 30%;
}

@media (max-width: 768px) {
  .contact-img {
    margin-top: 40px;
  }
}

/* University */
#university {
  text-align: center;
  margin: 10vh auto;
}

.uni-box {
  padding: 0 15px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.uni-img {
  width: 100%;
  vertical-align: middle;
}

.announce-btn {
  text-align: center;
  top: 80vh;
  position: absolute;
  & > a > h3 {
    color: #fdd047;
    border: 4px solid #fdd047;
    padding: 5px 10px;
    transition: 0.3s ease-out;
    &:hover {
      color: #fdd047;
      background: #fff;
      border: 4px solid #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue